import React from "react";
import { cls } from "@wss/cls";
import { upperCaseFirst } from "@wss/utilities/strings";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { GroupMember, Product } from "~/common/Store/models/ProductListing";
import isActiveSale from "../isActiveSale";
import { ProductListingView } from "~/productListing/ProductBox/AddToCart";

interface Props {
  groupingValue: string;
  product: Product;
  isCompareWithProductBox?: boolean;
  isOnCompareProductsPage?: boolean;
  isCarouselProductBox?: boolean;
  productListingView?: ProductListingView;
  handleGroupingChange: (
    event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => void;
}

const getSuffixType = (x: GroupMember) => x.configurationOptions[0]!.name;

const shouldHideSuffixPrice = (suffix: GroupMember) =>
  suffix.price.applyTypeLPriceToPlatinumPlus ||
  suffix.price.displayMinimumAdvertisedPrice;

export default ({
  groupingValue,
  product,
  handleGroupingChange,
  isCompareWithProductBox,
  isOnCompareProductsPage,
  isCarouselProductBox,
  productListingView,
}: Props) => {
  const { groupingAttributes } = product;
  /** TODO: Catalog should give the title attribute */
  const groupMembers = groupingAttributes.groupMembers
    .map((groupMemberOriginal) => ({
      ...groupMemberOriginal,

      title: groupMemberOriginal.configurationOptions[0]!.value,
      activeSale: isActiveSale(groupMemberOriginal.price),
    }))
    .sort(function handleSort(a, b) {
      return a.title?.localeCompare(b.title);
    });

  return (
    <select
      value={groupingValue}
      className={cls(
        "grouping-select-test",
        "suffix_dropdown",
        "configure",
        "item_number",
        isOnCompareProductsPage && "mb-[8.5px]",
      )}
      style={
        isCompareWithProductBox ||
        isCarouselProductBox ||
        isOnCompareProductsPage ||
        productListingView === "topProductsCarousel"
          ? { marginLeft: "-30px", width: `calc(100% + 30px)` }
          : {}
      }
      name="item_number"
      title={getSuffixType(groupingAttributes.groupMembers[0]!)}
      onChange={handleGroupingChange}
      data-testid="itemAddCartGrouping"
    >
      <option disabled value="">
        {}
        {upperCaseFirst(getSuffixType(groupingAttributes.groupMembers[0]!))}
      </option>
      {groupMembers.map((groupMember) => (
        <option
          key={groupMember.itemNumberId}
          value={groupMember.itemNumber}
          data-testid="itemAddCartMember"
        >
          {groupMember.title}
          {shouldHideSuffixPrice(groupMember)
            ? ""
            : ` - ${formatAsCurrency.formatIfUndefined(
                groupMember.activeSale
                  ? groupMember.price.salePrice
                  : groupMember.price.price,
              )}/${groupMember.unitOfMeasurement}`}
        </option>
      ))}
    </select>
  );
};
